import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { brandItem } from '../types/brandSchema';
import { RegionQueryDto } from './api.dto';

export const fetchAkbBrands = async (regionId: number): Promise<brandItem[]> => {
  return await MyAxios.get(`/api/akb/brands?regionId=${regionId}`)
    .then(handleResponse)
    .catch(error => handleError(error, []));
};

export const getAkbBrandList = createAsyncThunk<brandItem[], RegionQueryDto>('brand/getAkbBrandList', async query => {
  return await fetchAkbBrands(query.regionId);
});
